import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

export default function useSetFavorite() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (uuid: string) => {
      await api.post('user/toggle-favorite', { uuid })
      await invalidate.userLearningAssignments()
      await invalidate.favorites()
    },
  })
}
